import React from 'react';
import { Link } from 'react-router-dom';

interface LegalPageLayoutProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <div className="sticky top-0 z-10 bg-indigo-600 px-6 py-3 flex items-center justify-between">
        <Link to="/" className="text-white font-bold text-lg tracking-tight">
          Sahayy
        </Link>
        <Link to="/" className="text-indigo-200 text-sm hover:text-white transition-colors">
          ← Back to Home
        </Link>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">{title}</h1>
          {lastUpdated && (
            <p className="text-gray-400 text-sm italic">Last updated: {lastUpdated}</p>
          )}
          <div className="w-12 h-1 bg-indigo-600 rounded-full mx-auto mt-4" />
        </div>

        <div className="prose prose-gray max-w-none text-gray-600 leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

export const LegalSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-indigo-700 text-lg font-bold mb-3 pb-2 border-b border-gray-100">
      {title}
    </h2>
    {children}
  </section>
);

export const LegalList: React.FC<{ items: (string | React.ReactNode)[] }> = ({ items }) => (
  <ul className="list-disc ml-6 my-2 space-y-1.5">
    {items.map((item, i) => (
      <li key={i} className="pl-1">{item}</li>
    ))}
  </ul>
);

export default LegalPageLayout;
